export default "var ORNA_VERSION = 769;"